import WorkoutData from '@src/data/workout-data'
import camelcaseKeys from 'camelcase-keys'

export class TrainingDay {
  id: number | null
  position: number
  restDays: number
  workout: WorkoutData | null
  workoutAsArray: WorkoutData[]
  immutable: boolean

  constructor (attributes) {
    Object.assign(this, attributes)
    if (!this.workoutAsArray) {
      this.workoutAsArray = []
    }
    if (this.workout) {
      this.workoutAsArray = [new WorkoutData({ ...this.workoutAsArray[0], ...camelcaseKeys(this.workout, { deep: true }) })]
    }
  }
}

export default class TrainingPlan {
  id: number | null
  name: string = ''

  totalDayCount: number = 0
  trainingDayCount: number = 0

  averageDurationInMin: number = 0

  homeWorkoutCount: number = 0
  stationWorkoutCount: number = 0
  estimatedMet: number = 0

  startDate: string
  endDate: string
  started: boolean
  completed: boolean

  trainingDays: TrainingDay[]

  equipment: string[] = []

  previewImage: string = ''
  holderType: string = ''

  constructor (attributes?) {
    Object.assign(this, attributes)
    this.setDefaultDisplayImage()
    if (!attributes || !attributes.equipment) {
      this.equipment = []
    }
  }

  get summary () {
    return {
      trackedWorkouts: this.stationWorkoutCount,
      homeWorkouts: this.homeWorkoutCount,
      totalDays: this.totalDayCount,
      workouts: this.stationWorkoutCount + this.homeWorkoutCount,
      workoutDays: this.trainingDayCount,
      duration: this.averageDurationInMin,
      restDays: this.totalDayCount - this.trainingDayCount,
      estimatedMetValue: this.estimatedMet
    }
  }

  get trainingPlanType (): string {
    // return this.stationWorkoutCount > 0 ? 'tracked' : 'home'
    return this.holderType.toLowerCase()
  }

  get displayImage (): string {
    return this.previewImage
  }

  setDefaultDisplayImage () {
    this.previewImage = `/assets/icon/brand/default-workout/${this.id! % 30 || 0}.jpg`
  }
}
